/* eslint-disable import/prefer-default-export */
export const formatDateAEL = (dateString: string, timeString: string) => {
    if (dateString === '-' || timeString === '-') {
        return '-';
    }
    const [year, month, day] = dateString.split('-').map(Number);
    const hours = parseInt(timeString.slice(0, 2), 10);
    const minutes = parseInt(timeString.slice(2), 10);
    const dateObj = new Date(year, month - 1, day, hours, minutes);
    if (dateObj.toString() === 'Invalid Date') {
        const dateTimeString = `${dateString} ${timeString}`;
        const formattedDate = new Date(dateTimeString).toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        });

        return formattedDate;
    }
    return dateObj;
};
